export const trackingEvents = {
  PAGE: { VIEWED: 'appeals.detail.viewed' },
  BACK: { CLICKED: 'appeals.detail_back.clicked' },
  SAVE: { CLICKED: 'appeals.detail_save.clicked' },
}
